import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import { Toaster } from "@/components/ui/sonner";

function App() {
    useEffect(() => {
        document.title = "Luna Markab Publicitaria · Agencia retro de alto impacto";
    }, []);

    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<LandingPage />} />
                </Routes>
            </BrowserRouter>
            <Toaster
                position="top-center"
                toastOptions={{
                    style: {
                        background: "#1E3660",
                        color: "#F4F1E1",
                        border: "3px solid #0097B2",
                        borderRadius: "0px",
                        fontFamily: "Outfit, sans-serif",
                        fontWeight: 600,
                    },
                }}
            />
        </div>
    );
}

export default App;
